import styled from '@emotion/styled';

import type React from 'react';

const StyledBox = styled.div`
  width: 140px;
  height: 140px;
  display: inline-block;
  position: relative;
  color: rgb(0, 75, 84);
  flex: 0 0 140px;
  &::after {
    content: '';
    position: absolute;
    box-sizing: border-box;
    width: 136px;
    height: 136px;
    left: 2px;
    top: 2px;
    border-radius: 50%;
    border: 5px solid rgba(0, 75, 84, 0.25);
  }
  svg {
    animation: 1100ms linear 0s infinite normal none running animation;
  }
  .circle {
    stroke-linecap: round;
    stroke: currentcolor;
    stroke-dasharray: 80px, 200px;
    stroke-dashoffset: 0;
  }
  @keyframes animation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }
`;

export const LoadingAnimatedIcon = () => {
  return (
    <StyledBox>
      <svg viewBox="22 22 44 44">
        <circle cx="44" cy="44" r="20" fill="none" strokeWidth="2" className="circle"></circle>
      </svg>
    </StyledBox>
  );
};
